export default {
  'Choose File': 'Choisir un fichier',
  'Please paste a URL': 'Veuillez coller une adresse URL',
  'Loading': 'Chargement',
  'Analyzing': 'Analyse en cours',
  'Try a sample': 'Essayer un échantillon',
  'Sorry, error occurs when analyzing the URL.': "Désolé, une erreur se produit lors de l'analyse de l'URL.",
  'Upload a photo': 'Téléchargez une photo',
  "Drag and drop files to the upload box.": 'Faites glisser et déposez les fichiers dans la boîte de téléchargement.',
  'Please select the proper position with portrait.': 'Veuillez sélectionner la bonne position avec le portrait.',
  'downloading': 'Téléchargement',
}